(function () {
(function($) {
    const behavior = "polyu_theme.faculty_block";
    Drupal.behaviors[behavior] = {
        attach: (context, settings)=>{}
    };
    $(function() {
        const currentURL = window.location.href;
        // Function to check if current link has PG in it, if so adds pg c;ass to element (for styling)
        // Change  indexOf("x") to what the url contains i.e. pg/ug
        if (currentURL.indexOf("pg") > -1) {
            var element = $(".block--faculty-info-wrapper");
            element.addClass("pg-version");
            element.prepend('<div class="color-overlay"></div>');
        }
    });
    $(function() {
        $(".field--show-faculty-blocks .block--faculty-title:contains('Faculty of')").html(function(_, html) {
            return html.replace(/(Faculty of)/g, '<span class="small">$1</span>');
        });
        $(".field--show-faculty-blocks .block--faculty-title:contains('School of')").html(function(_, html) {
            return html.replace(/(School of)/g, '<span class="small">$1</span>');
        });
        $(".field--show-faculty-blocks .views--content-wrapper .views--content-wrapper-inner").last().append('<div class="views-field views-field-nothing"></div>');
        if ($(".field--show-faculty-blocks .views--content-wrapper .views--content-wrapper-inner .views-field-nothing").last().find(".paragraph--custom-faculty-card").length == 0) $(".field--show-faculty-blocks .views--content-wrapper .views--content-wrapper-inner .views-field-nothing").last().append($(".paragraph--custom-faculty-card"));
    });
})(jQuery);

})();
//# sourceMappingURL=paragraph--faculty-blocks.js.map
